export const columnHeaders = [
  "First Name",
  "Last Name",
  "Email",
  "Phone",
  "Resume Link",
  "Average Review Score",
  "Decision",
  "Lead Consultant Notes"
];

const decisionMapping = ["Decline", "Consider", "Advance"];

const parseDecision = (score: number) => {
  if (score === null) return "";
  return decisionMapping[score - 1];
};

export const generateColumnData = (applications: any, includeReviews: boolean = true) => {
  return applications.map((application: any) => {
    const leadConsultantReview = application.reviews?.find((review: any) => review.isRecommendation === true);
    const decision = leadConsultantReview ? parseDecision(leadConsultantReview.score) : "";
    const leadConsultantNotes = leadConsultantReview?.comments || "";

    return [
      application.applicant?.firstName || "",
      application.applicant?.lastName || "",
      application.email || "",
      application.phone || "",
      application.resume || "",
      ...(includeReviews ? [application.reviewScoreAverage || "", decision, leadConsultantNotes] : [])
    ];
  });
};
